import { authHeader, history } from "../_helpers";
import { handleResponse } from "../_helpers/response";
import config from "../config";
export const cctnsService = {
  cctnsMissingRoleWiseList,
  cctnsMissingRoleWiseCount,
  updateCctnsMissing,
  addCctnsMissing,
};
const baseUrl = config.apiGateway.baseUrl;
function cctnsMissingRoleWiseList(values) {
  const requestOptions = {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
      ...authHeader(),
    },
    body: JSON.stringify(values),
  };

  return fetch(
    `${baseUrl}/criminal/cctnsMissingRoleWiseList/`,
    requestOptions,
  ).then(handleResponse);
}
function cctnsMissingRoleWiseCount(values) {
  const requestOptions = {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
      ...authHeader(),
    },
    body: JSON.stringify(values),
  };

  return fetch(
    `${baseUrl}/criminal/cctnsMissingRoleWiseCount/`,
    requestOptions,
  ).then(handleResponse);
}
function updateCctnsMissing(values) {
  const requestOptions = {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
      ...authHeader(),
    },
    body: JSON.stringify(values),
  };

  return fetch(
    `${baseUrl}/criminal/updateCctnsMissing/`,
    requestOptions,
  ).then(handleResponse);
}
function addCctnsMissing(values) {
  const requestOptions = {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
      ...authHeader(),
    },
    body: JSON.stringify(values),
  };

  return fetch(`${baseUrl}/criminal/addCctnsMissing/`, requestOptions).then(
    handleResponse,
  );
}
